/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.string,
};

const defaultProps = {
  value: null,
};

const HeaderField = ({ label, value }) => (
  <>
    <p className="field-label" title={label}>
      {label}
    </p>
    <span className="light-weight" title={value}>
      {value}
    </span>
  </>
);

HeaderField.defaultProps = defaultProps;
HeaderField.propTypes = propTypes;
export default HeaderField;
